import { useState } from 'react';
import { Collapse, List, ListItemButton } from '@mui/material';
import {
  LanguageToggleIcon,
  langaugesItems,
  LanguageIcon,
  languageIconMap,
} from './LanguageSelector';

type Props = { closeDrawer(): void };

export function MobileLanguageSelector({ closeDrawer }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  function toggleIsOpen() {
    setIsOpen(o => !o);
  }

  return (
    <>
      <ListItemButton
        color="ButtonText"
        sx={{ justifyContent: 'center' }}
        onClick={toggleIsOpen}
        aria-controls={isOpen ? 'basic-menu' : undefined}
        aria-expanded={isOpen ? 'true' : undefined}
        aria-label="select language"
      >
        <LanguageToggleIcon />
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto">
        <List disablePadding>
          {langaugesItems.map(lang => (
            <ListItemButton
              key={lang.code}
              sx={{ px: 0, justifyContent: 'center' }}
              onClick={closeDrawer}
            >
              <LanguageIcon
                imgSrc={languageIconMap[lang.code]}
                language={lang.code}
                languageName={lang.name}
              />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}
